// Capas flotantes que no se pisan (revisor E2E del paquete final, H2:
// #1401 v5 × #1450).
//
// Dos piezas flotan sobre el Turno sin ser modales: la marca de
// acompañamiento de #1450 (`AcompanamientoMarca.jsx`, z-index 1200, anclada a
// un control) y la tarjeta "Estás en tu prueba gratuita" / "Tu plan está en
// gracia" de #1401 (`SuscripcionGate.js`, z-index 1199, pegada abajo). A 390
// px no hay dónde poner las dos: la marca del paso 1 sale bajo el segmento
// "Evolución" y cae justo encima de la tarjeta, así que se comía el toque de
// "Cerrar aviso". Arriba del ancla tampoco cabe: taparía "Pegar censo" y
// "Agregar paciente", el camino real que R7 de #1450 exige libre. Y subir la
// tarjeta por encima de la marca solo invierte el problema (taparía
// "Entendido"/"Cerrar" de la marca).
//
// Regla: la marca manda mientras está en pantalla (es corta, se cierra con un
// toque y solo la ve quien nunca generó), y la tarjeta CEDE solo si de verdad
// se solaparían: queda oculta (`visibility: hidden`, sin recibir toques) y
// vuelve sola cuando la marca se cierra o se mueve. Nunca se pisan dos cosas
// tocables. En 1280 no se tocan y se ven las dos.
//
// Registro en memoria del módulo: la marca publica el rect de su burbuja (y el de su ancla
// cuando es un control: #1450 R14, F4, la tarjeta tapaba el Generar a 390x844) y la
// tarjeta se suscribe. Sin React context a propósito: la tarjeta vive en las
// rutas (fuera del Turno) y la marca en un portal del Turno.

const capas = new Map();
const suscriptores = new Set();

const avisar = () => {
  suscriptores.forEach((fn) => {
    try {
      fn();
    } catch {
      /* un suscriptor roto no corta a los demás */
    }
  });
};

const mismo = (a, b) =>
  a && b && a.top === b.top && a.left === b.left && a.right === b.right && a.bottom === b.bottom;

// `rect` null o sin área = la capa ya no está en pantalla.
export const publicarCapa = (id, rect) => {
  const plano =
    rect && rect.width > 0 && rect.height > 0
      ? { top: rect.top, left: rect.left, right: rect.right, bottom: rect.bottom }
      : null;
  const previo = capas.get(id) || null;
  if (!plano) {
    if (!previo) return;
    capas.delete(id);
    avisar();
    return;
  }
  if (mismo(previo, plano)) return;
  capas.set(id, plano);
  avisar();
};

export const retirarCapa = (id) => publicarCapa(id, null);

export const suscribirCapas = (fn) => {
  suscriptores.add(fn);
  return () => {
    suscriptores.delete(fn);
  };
};

export const capasEnPantalla = () => Array.from(capas.values());

// Solape con un margen de aire (px): tocarse borde con borde también cuenta,
// porque un dedo no apunta al píxel.
export const seSolapan = (a, b, margen = 4) =>
  Boolean(a && b) &&
  a.left < b.right + margen &&
  b.left < a.right + margen &&
  a.top < b.bottom + margen &&
  b.top < a.bottom + margen;

export const tapadaPorCapa = (rect) =>
  Boolean(rect && rect.width > 0 && rect.height > 0) && capasEnPantalla().some((c) => seSolapan(rect, c));

// Solo para tests.
export const __limpiarCapas = () => {
  capas.clear();
  suscriptores.clear();
};
